import { createContext, useContext, useState, useCallback, useRef } from "react";

/* Toast system — port of shell.js `Shell.toast`. Call `toast(msg, "ok"|"err")`
 * from anywhere via the useToast() hook. Rendered into a fixed #toaster stack. */
const ToastCtx = createContext(() => {});

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const toast = useCallback((msg, kind = "") => {
    const id = ++idRef.current;
    setToasts((t) => [...t, { id, msg, kind }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 4200);
  }, []);

  return (
    <ToastCtx.Provider value={toast}>
      {children}
      <div id="toaster">
        {toasts.map((t) => (
          <div key={t.id} className={"toast " + t.kind}>
            {t.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
